import React from 'react';
import LayoutInput from 'components/forms/layoutInput';
import Col from 'components/Col';
import ValidationGroup from 'helpers/validation';
import PropTypes from 'prop-types';
import {inRange} from './helpers';
import {injectIntl, intlShape} from 'react-intl';

class Round extends React.Component {
  static propTypes = {
    group: PropTypes.instanceOf(ValidationGroup).isRequired,
    intl: intlShape,
  };

  static initialState = {
    diameter: undefined,
  };

  state = Round.initialState;

  update = ({key, value}) => {
    this.setState({[key]: parseFloat(value)});
  };

  volume = averageDepth => {
    return Math.pow(this.state.diameter, 2) * averageDepth * 5.9;
  };

  reset = () => {
    this.setState(Round.initialState);
  };

  render() {
    const {formatMessage} = this.props.intl;

    return <Col md={4}>
      <LayoutInput type='number'
                   dataKey='diameter'
                   step='0.01'
                   autoFocus
                   group={this.props.group}
                   validate={inRange}
                   toolTip={formatMessage({id: 'quick-calcs.pool-volume.diameter.tooltip'})}
                   label={formatMessage({id: 'quick-calcs.pool-volume.diameter'})}
                   dataChanged={this.update}
                   value={this.state.diameter}
                   required />
    </Col>;
  }
}

export default injectIntl(Round, {withRef: true});
